import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function AuthCallbackPage() {
  const navigate = useNavigate();
  const { completeSignIn } = useAuth();
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    async function run() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const oauthError = params.get('error');
      const oauthErrorDescription = params.get('error_description');

      if (oauthError) {
        setError(oauthErrorDescription || oauthError);
        return;
      }

      if (!code) {
        setError('Missing authorization code from identity provider.');
        return;
      }

      try {
        const target = await completeSignIn(code, state);
        navigate(target || '/', { replace: true });
      } catch (err) {
        setError(err?.message || 'Unable to complete sign-in.');
      }
    }

    run();
  }, [completeSignIn, navigate]);

  if (!error) {
    return <div className="card text-center">Completing sign-in...</div>;
  }

  return (
    <div className="card" style={{ maxWidth: '560px', margin: '2rem auto' }}>
      <h2 className="card-title mb-4">Sign-In Error</h2>
      <div className="badge badge-error mb-4">{error}</div>
      <Link className="btn btn-primary" to="/login">
        Back to Login
      </Link>
    </div>
  );
}

export default AuthCallbackPage;
